import { type ReactNode } from "react"
import { Button, Card, Container, Stack, Typography } from "@octopus-energy/coral/atoms"
import { type StyledCardVariant } from "@octopus-energy/coral-design/recipes"
import { useTranslations } from "next-intl"
import { EmailLink, PhoneLink } from "@/components/atoms"
import { AsideIllustration } from "@/components/molecules/AsideIllustration"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { CUSTOMER_SERVICE_EMAIL } from "../constants/email"
import { CUSTOMER_SERVICE_PHONE } from "../constants/phone"

function Content() {
    const t = useTranslations("FAQHelpCard")

    return (
        <Stack
            flexDirection="column"
            gap="md"
        >
            <Typography
                textStyle="h4"
                component="p"
                textWrap="pretty"
            >
                {t("question")}
            </Typography>
            <Typography
                color="inherit"
                wordBreak="break-word"
                textAlign="start"
            >
                {t.rich("customerService", {
                    emailLink: () => <EmailLink email={CUSTOMER_SERVICE_EMAIL} />,
                    phoneLink: () => <PhoneLink phone={CUSTOMER_SERVICE_PHONE} />,
                })}
            </Typography>
            <Container
                marginTop="md"
                fullWidth
            >
                <Button
                    fullWidth
                    href={storyblokRoutesPaths.landing.resolve({
                        pathParams: { landingId: "contact" },
                    })}
                >
                    {t("moreInfo")}
                </Button>
            </Container>
        </Stack>
    )
}

type FaqHelpCardProps = {
    theme?: StyledCardVariant["theme"]
    image?: ReactNode
}

export function FaqHelpCard({ theme = "base900", image }: FaqHelpCardProps) {
    if (!image) {
        return (
            <Card
                borderless
                theme={theme}
            >
                <Content />
            </Card>
        )
    }

    return (
        <Card
            borderless
            theme={theme}
        >
            <AsideIllustration image={image}>
                <Content />
            </AsideIllustration>
        </Card>
    )
}

FaqHelpCard.messages = ["FAQHelpCard"] as const
